import React, { useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import ProductsList from './Components/ProductsList/ProductsList';
import ChevronDown from '../../Assets/Dropdown/ChevronDown.svg';
import { useOutsideClickForTwoRef } from '../../Hooks/useOutsideClickForTwoRef';
import { camelCaseToReadable } from '../../lib/utils/utils';

function ProductInsightsPage() {
    const location = useLocation();

    const dropdownButtonRef = useRef(null);
    const dropdownRef = useRef(null);

    const [dropdownOption, setDropdownOption] = useState('allProducts');
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdownButton = () => {
        setDropdownOpen(!dropdownOpen);
    }

    const handleOptionClick = (option) => {
        setDropdownOption(option);
    }

    useOutsideClickForTwoRef(dropdownButtonRef, dropdownRef, () => {
        setDropdownOpen(false);
    });

    return (
        <div className="w-full overflow-y-scroll pb-20">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold text-2xl">Product Insights</h1>
                </div>

                <button ref={dropdownButtonRef} onClick={handleDropdownButton} className="relative cursor-pointer rounded-md border border-[#EAEAEA] p-[10px_2px_10px_8px] flex items-center gap-1">
                    <p className='min-w-24 font-semibold text-[14px] leading-[22px] text-[#121212] text-left whitespace-nowrap'>
                        {camelCaseToReadable(dropdownOption)}
                    </p>

                    <div className="size-[22px] flex items-center justify-center">
                        <img src={ChevronDown} alt="" />
                    </div>

                    {
                        dropdownOpen && 
                        <div ref={dropdownRef} className="absolute z-10 top-11 right-0 w-[158px] bg-[#FFFFFF] rounded-lg font-semibold text-[14px] leading-[22px] shadow-[0px_0px_12px_0px_#0000003D] text-[#121212]">
                            <p onClick={() => handleOptionClick('allProducts')} className='px-2 py-[10px] text-left hover:bg-[#F5F5F5]'>All Products</p>

                            <p onClick={() => handleOptionClick('topOrdered')} className='px-2 py-[10px] text-left hover:bg-[#F5F5F5]'>Top Ordered</p>

                            <p onClick={() => handleOptionClick('lowPerformance')} className='px-2 py-[10px] whitespace-nowrap text-left hover:bg-[#F5F5F5]'>Low Performance</p>
                        </div>
                    }
                </button>
            </div>

            <ProductsList />
        </div>
    );
}

export default ProductInsightsPage;
